import { render, staticRenderFns } from "./StudentManagement.vue?vue&type=template&id=1a00fe98&scoped=true"
import script from "./StudentManagement.vue?vue&type=script&lang=js"
export * from "./StudentManagement.vue?vue&type=script&lang=js"
import style0 from "./StudentManagement.vue?vue&type=style&index=0&id=1a00fe98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a00fe98",
  null
  
)

export default component.exports